const shortLinkDataCache = new Map<string, Promise<unknown>>();

/**
 * Загрузка данных короткой ссылки с кэшем по id
 */
export const getCachedShortLinkData = <T>(
  shortLink: string,
  loader: () => Promise<T>
): Promise<T> => {
  const cachedData = shortLinkDataCache.get(shortLink) as Promise<T> | undefined;

  if (cachedData) {
    return cachedData;
  }

  const dataPromise = loader().catch((e) => {
    shortLinkDataCache.delete(shortLink);
    throw e;
  });

  shortLinkDataCache.set(shortLink, dataPromise);

  return dataPromise;
};
